export default __webpack_public_path__ + "static/media/rio.6ef2217f.jpg";